import React from 'react'
import { useSelector } from 'react-redux'
import SectionsCollapsible from './SectionCollapsable'
import './styles.scss'
import { Draggable, Droppable } from 'react-beautiful-dnd'

const SectionsContainer = ({ openCard }) => {
  const { conversations, sectionsOrder } = useSelector(state => state.inchat.sections)
  return (
    <Droppable
      droppableId={'section-list'}
      type={'SECTIONS'}
      direction='vertical'
    >
      {(provider_section_droppable, snapshot) => (
        <div
          className={`
            inchat-menu__container inchat-sections-menu
            ${snapshot.isDraggingOver ? 'inchat-sections-menu--dragging' : ''}
          `}
          ref={provider_section_droppable.innerRef}
          {...provider_section_droppable.droppableProps}
        >
          {sectionsOrder && sectionsOrder.map(( orderId, index ) => {
            const conversation = conversations.find(con => con._id === orderId)
            if(!conversation) return null
            return(
              <Draggable
                key={orderId}
                draggableId={orderId}
                index={index}
                isDragDisabled={!orderId ? true : false}
              >
                {(provider_section_draggable) => (

                  <div
                    ref={provider_section_draggable.innerRef}
                    style={{
                      ...provider_section_draggable.draggableProps.style
                    }}
                    {...provider_section_draggable.draggableProps}
                    {...provider_section_draggable.dragHandleProps}
                  >
                    <SectionsCollapsible
                      conversation={conversation}
                      openCard={openCard}
                    />
                  </div>
                )}
              </Draggable>
            )}
          )}
          {provider_section_droppable.placeholder}
        </div>
      )}
    </Droppable>
  )
}

export default SectionsContainer
